import React from "react"
import { useDispatch } from "react-redux"
import { raiseToast } from "../../../services/redux/reducers/toast/toast"

import CopyToClipboard from "../../../common/CopyToClipboard"

const PendingBuyerReq = (props) => {
    const { pendingReqList } = props
    const dispatch = useDispatch()

    return (
        <div>
            <p>Below Reqs have unpunched items scheduled for over 15 days ago. Please update the schedules before punching a new requirement.</p>
            <hr />
            <div className="p-card" style={{ maxHeight: "200px", overflowY: "auto", padding: "1rem" }}>
                {pendingReqList?.map((each, index) => (
                    <>
                        <div key={index} className="flex flex-row">
                            <span>{each?.docNo}</span>
                            {each?.docNo && (
                                <CopyToClipboard text={each.docNo} />
                            )}
                        </div>
                        <br />
                    </>
                ))}
            </div>
        </div>
    )
}

export default PendingBuyerReq
